<template>
  <div class="edu-faq-area sectionBg15 ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="edu-faq-content">
            <p class="sub-title">Sıkça Sorulan Sorular</p>
            <h2>Genel <span class="shape02">Sorular</span></h2>
          </div>
          <div class="accordion edu-faqs-list" id="accordionFlushExample">
            <div class="accordion-item faq-item">
              <h2 class="faq-header" id="flush-headingOne">
                <button class="accordion-button faq-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  Derslere nasıl erişebilirim?
                </button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse faq-collapse"
                aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="faq-item-body">
                  <p>
                    Tüm derslere internet bağlantısı olan bilgisayar, tablet veya telefon üzerinden erişebilirsiniz.
                    İstediğiniz zaman giriş yapıp derslere kaldığınız yerden devam edebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item faq-item">
              <h2 class="faq-header" id="flush-headingTow">
                <button class="accordion-button faq-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTow" aria-expanded="false" aria-controls="flush-collapseTow">
                  Eğitmenler kimlerdir?
                </button>
              </h2>
              <div id="flush-collapseTow" class="accordion-collapse collapse faq-collapse"
                aria-labelledby="flush-headingTow" data-bs-parent="#accordionFlushExample">
                <div class="faq-item-body">
                  <p>
                    Alanında uzman, uzun yıllardır eğitim veren ve sektör deneyimi olan eğitmenlerimiz dersleri
                    hazırlamaktadır. Eğitmen detaylarını “Eğitmen Kadromuz” sayfasında inceleyebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item faq-item">
              <h2 class="faq-header" id="flush-headingThree">
                <button class="accordion-button faq-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                  Sertifika veriliyor mu?
                </button>
              </h2>
              <div id="flush-collapseThree" class="accordion-collapse collapse faq-collapse"
                aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                <div class="faq-item-body">
                  <p>
                    Evet. Tamamladığınız her kurs için ücretsiz dijital sertifika alabilirsiniz. Sertifikalarınızı
                    profilinizden indirip paylaşabilirsiniz.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-item faq-item">
              <h2 class="faq-header" id="flush-headingFour">
                <button class="accordion-button faq-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                  Derslere istediğim zaman katılabilir miyim?
                </button>
              </h2>
              <div id="flush-collapseFour" class="accordion-collapse collapse faq-collapse"
                aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                <div class="faq-item-body">
                  <p>
                    Evet. Dersler tamamen esnek yapıdadır. İstediğiniz saatte, istediğiniz cihazdan katılım
                    sağlayabilirsiniz. Kendi hızınıza göre öğrenmeye devam edebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="edu-about-image">
            <img src="../../assets/img/all-img/faq.png" alt="banner-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQ",
};
</script>